export default __webpack_public_path__ + "static/media/icono-domicilio-blanco.9cb69b86.svg";